import React from "react";
import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import { lighten } from "polished";

const LinkStyles = styled.a.attrs(({ text, children }) => ({
  children: text || children
}))`
  pointer-events: ${props => (props.disabled ? "none" : "auto")};
  color: ${props => props.color || props.theme.components.link.color};
  font-size: ${props => props.fontSize || props.theme.components.link.fontSize};
  line-height: ${props => props.lineHeight};
  font-weight: ${props =>
    props.fontWeight || props.theme.components.link.fontWeight};
  text-decoration: ${props => props.textDecoration || "none"};
  background: ${props => props.background || "inherit"};
  transform: ${props => props.transform};
  text-transform: ${props => props.textTransform};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  padding-bottom: ${props => props.paddingBottom};
  cursor: ${props => props.cursor || "pointer"};
  position: ${props => props.position};
  right: ${props => props.right};
  padding-right: ${props => props.paddingRight};
  border-right: ${props => props.borderRight};
  margin-bottom: ${props => props.marginBottom};
  margin-top: ${props => props.marginTop};
  display: ${props => props.display};
  height: ${props => props.height};
  width: ${props => props.width};
  text-decoration-color: ${props => props.textDecorationColor};
  -webkit-text-decoration-color: ${props => props.textDecorationColor};
  ${props => props.uppercase && "text-transform: uppercase"};
  ${props => props.opacity && "opacity: 0.8"};

  :focus {
    outline: 2px solid inherit;
    outline-offset: ${props => props.outlineOffset};
  }

  &:hover {
    text-decoration: ${props =>
      props.default ? "none" : props.fontDecoration};
    color: ${props =>
      props.default ? props.textDecorationColor : lighten(0.1, props.color)};
    ${props => props.lighten && `opacity: 0.5;`};
    text-decoration-color: ${props => props.textDecorationColor};
    -webkit-text-decoration-color: ${props => props.textDecorationColor};
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 992px) {
    margin-bottom: ${props => props.mdMarginBottom};
  }

  // Small devices (landscape phones, less than 768px)
  @media (max-width: 767px) {
    font-size: ${props => props.mobileSmFontSize};
  }

  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    font-size: ${props => props.mobileXsFontSize};
  }
`;

const Link = ({ opacity, ...rest }) => <LinkStyles {...rest} />;

Link.defaultProps = {
  href: "#",
  color: "#000",
  fontDecoration: "underline",
  uppercase: false,
  lighten: false,
  opacity: false,
  disabled: false,
  hasSameBackground: false
};

Link.propTypes = {
  color: PropTypes.string,
  href: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontDecoration: PropTypes.string,
  uppercase: PropTypes.bool,
  lighten: PropTypes.bool,
  opacity: PropTypes.bool,
  cursor: PropTypes.string,
  disabled: PropTypes.bool,
  mobileSmFontSize: PropTypes.string,
  mobileXsFontSize: PropTypes.string,
  display: PropTypes.string,
  textDecoration: PropTypes.string,
  textDecorationColor: PropTypes.string,
  lineHeight: PropTypes.string,
  background: PropTypes.string
};

export default Link;
